import { Component, OnInit, ViewChild } from '@angular/core';
import { IssueRow, IssueRelation, Issue } from '../../issues.model';
import { GridComponent } from '../../../core/shared/grid/grid.component';
import { IssuesRest } from '../../issues.rest';
import { SelectionMode } from '../../../core/shared/grid/grid.model';
import { IssuesListComponent } from '../../issues-list/issues-list.component';
import { IssueService } from '../../issue.service';
import { DialogService } from '../../../core/shared/dialog/dialog.service';
import { DialogConfig } from '../../../core/shared/dialog/dialog-config';

@Component({
  selector: 'app-issue-relations',
  templateUrl: './issue-relations.component.html',
  styleUrls: ['./issue-relations.component.scss']
})
export class IssueRelationsComponent implements OnInit {

  public relations: IssueRelation[];
  public isEditable: boolean;
  private issueId: number;
  private issueIsNew: boolean;


  @ViewChild(GridComponent) grid: GridComponent;

  private headers = [
    { displayName: 'Identyfikatior', propertyName: 'childId', propertyType: 'number' },
    { displayName: 'Tytuł', propertyName: 'childTitle', propertyType: 'string' },
    { displayName: 'Data rozpoczęcia', propertyName: 'childStartDate', propertyType: 'date' },
    { displayName: 'Data końcowa', propertyName: 'childEndDate', propertyType: 'date' },
    { displayName: 'Budżet', propertyName: 'childBudget', propertyType: 'number' },
    { displayName: 'Ilość godzin w budżecie', propertyName: 'childTimeBudget', propertyType: 'number' },
    { displayName: 'Ilość przepracowanych godzin', propertyName: 'childWorklogsTimeSpent', propertyType: 'number' },
    { displayName: 'Opis', propertyName: 'childDescription', propertyType: 'string' }
  ];

  constructor(
    private rest: IssuesRest, 
    public dialog: DialogService,    
    private issueService: IssueService) { }

  ngOnInit() {
  }

  public setModel(relations: IssueRelation[], isEditable: boolean, issueId: number, issueIsNew: boolean) {
    this.relations = relations;
    this.isEditable = isEditable;
    this.issueId = issueId;
    this.issueIsNew = issueIsNew;
  }

  private addRelation() {
    const dialogconf = new DialogConfig();
    dialogconf.title = 'Wybierz zgłoszenia';
    dialogconf.selectionMode = SelectionMode.multi;
    dialogconf.maxwidth = '1000px';

    const ref = this.dialog.open(IssuesListComponent, dialogconf);
    ref.afterClosed.subscribe((result: IssueRow[]) => {

      if (result != null) {
        result.forEach(row => {
          if (this.issueId !== row.id && this.notExistInList(row.id)) {
            const element = new IssueRelation();
            element.parentId =  this.issueId;
            element.childId =  row.id;
            if (this.issueIsNew) {
              this.mapElement(element);
            } else {
              this.saveIssueRelation(element);
            }
          }
        });
      }
    });
  }

  saveIssueRelation(relation: IssueRelation) {
    this.rest.saveIssueRelation(relation).subscribe((rel: IssueRelation) =>
    {
      this.relations.push(rel);
      this.grid.refreshData();
    });
  }

  private removeRelation(row: IssueRelation) {
    if (row.id != null && row.id !== 0) {
      const action = this.rest.removeRelation;
      action.call(this.rest, row).subscribe();
    }
    this.relations.splice(this.relations.indexOf(row), 1);
    this.grid.refreshData();
  }


  get elements() {
    return this.relations.length > 12;
  }

  notExistInList(rowId: number): boolean {

    const exist = this.relations.find( x => x.childId === rowId);
    if (exist) {
      return false;
    }
    return true;
  }

  private mapElement(rel: IssueRelation) {
    this.rest.getIssue(rel.childId, true).subscribe((res: Issue) => {
      if (res != null) {
        const relation = new IssueRelation();
        relation.parentId = this.issueId;
        relation.childId = res.id;
        relation.childTitle = res.title;
        relation.childStartDate = res.startDate;
        relation.childEndDate =  res.endDate;
        relation.childBudget = res.budget;
        relation.childTimeBudget = res.timeBudget;
        relation.childWorklogsTimeSpent = res.worklogs.reduce((sum, current) => sum + current.timeSpent, 0);
        relation.childDescription = res.description;
        this.relations.push(relation);
        this.grid.refreshData();
      }
    });
  }
}
